export class SensorExtraction {
    id: string;
    sensorSettingId: string;
    type: string;
    settingId: string;
    pollingInterval: number;
    lastSyncAt: Date;
    active: boolean;
    createdAt: Date;
    updatedAt: Date;

    private spanishNames?: Record<string, string> = {
        id: "identificador",
        sensorSettingId: "ID de configuración de sensor",
        type: "tipo",
        settingId: "ID de configuración",
        pollingInterval: "intervalo de sincronización",
        lastSyncAt: "última sincronización",
        active: "activo",
        createdAt: "creado en",
        updatedAt: "actualizado en",
    };

    constructor(data?: Partial<SensorExtraction>) {
        this.id = data?.id ?? "";
        this.sensorSettingId = data?.sensorSettingId ?? "";
        this.type = data?.type ?? "";
        this.settingId = data?.settingId ?? "";
        this.pollingInterval = data?.pollingInterval ?? 0;
        this.lastSyncAt = data?.lastSyncAt ? new Date(data.lastSyncAt) : new Date();
        this.active = data?.active ?? false;
        this.createdAt = data?.createdAt ? new Date(data.createdAt) : new Date();
        this.updatedAt = data?.updatedAt ? new Date(data.updatedAt) : new Date();
    }

    getSpanishName(propertyName: string): string {
        if (this.spanishNames && this.spanishNames[propertyName]) {
            return this.spanishNames[propertyName];
        }
        return propertyName;
    }

    toPlainObject(): Record<string, any> {
        return {
            id: this.id,
            sensorSettingId: this.sensorSettingId,
            type: this.type,
            settingId: this.settingId,
            pollingInterval: this.pollingInterval,
            lastSyncAt: this.lastSyncAt,
            active: this.active,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
        };
    }

    // Métodos de utilidad específicos para SensorExtraction
    getNextSyncTime(): Date {
        const nextSync = new Date(this.lastSyncAt)
        nextSync.setMinutes(nextSync.getMinutes() + this.pollingInterval)
        return nextSync
    }

    isOverdue(): boolean {
        if (!this.active) return false
        const nextSync = this.getNextSyncTime()
        return new Date() > nextSync
    }

    getTimeSinceLastSync(): string {
        const now = new Date()
        const diff = now.getTime() - this.lastSyncAt.getTime()
        const minutes = Math.floor(diff / (1000 * 60))
        const hours = Math.floor(minutes / 60)
        const days = Math.floor(hours / 24)

        if (days > 0) return `${days} día(s)`
        if (hours > 0) return `${hours} hora(s)`
        return `${minutes} minuto(s)`
    }

    getTimeUntilNextSync(): string {
        if (!this.active) return "Inactivo"
        
        const nextSync = this.getNextSyncTime()
        const now = new Date()
        const diff = nextSync.getTime() - now.getTime()
        
        if (diff <= 0) return "Atrasado"
        
        const minutes = Math.floor(diff / (1000 * 60))
        const hours = Math.floor(minutes / 60)
        const days = Math.floor(hours / 24)

        if (days > 0) return `en ${days} día(s)`
        if (hours > 0) return `en ${hours} hora(s)`
        return `en ${minutes} minuto(s)`
    }
}
